import { oc } from "@orpc/contract";
import * as z from "zod";
import { drokAuditContract, drokUserAdminContract } from "./admin-rpc.js";
import { drokAssignmentContract, drokUserContract } from "./assignment-rpc.js";
import { drokCompanyModelsContract } from "./company-models.js";
import { drokCopyContract } from "./copy-rpc.js";
import { knowledgeContract } from "./knowledge.js";
import { drokTemplateContract } from "./template-rpc.js";

/** What the signed-in user may do in a Drok deployment, as the web app needs to know it. */
export const DrokAccessMeSchema = z.object({
  /** True for IT, and for everyone when access enforcement is off (dev and e2e). */
  canManageAgents: z.boolean(),
  /** Whether this deployment enforces IT and employee roles at all. */
  enforced: z.boolean(),
});
export type DrokAccessMe = z.infer<typeof DrokAccessMeSchema>;

/** Served on /drok-rpc, apart from the upstream appContract on /rpc. */
export const drokContract = {
  access: {
    me: oc.output(DrokAccessMeSchema),
  },
  copies: drokCopyContract,
  templates: drokTemplateContract,
  assignments: drokAssignmentContract,
  users: { ...drokUserContract, ...drokUserAdminContract },
  audit: drokAuditContract,
  companyModels: drokCompanyModelsContract,
  knowledge: knowledgeContract,
};
export type DrokContract = typeof drokContract;
